import { gql } from 'graphql-request';

import {
  GlobalCompanyTabCompanyType,
  GlobalCompanyTabCreatedAt,
  GlobalCompanyTabID,
  GlobalCompanyTabName,
  GlobalCompanyTabNanoID,
  GlobalCompanyTabPosition,
  GlobalCompanyTabRole,
  GlobalCompanyTabType,
  GlobalCompanyTabUpdatedAt,
  GlobalCompanyTabUser,
  GlobalCompanyTabUserID,
  GlobalCompanyTabUUID
} from '../globalCompanyTabsTypes';

import { UpdateItemGqlError } from '../../../types';

export interface UpdateGlobalCompanyTabQueryResponse {
  updateGlobalCompanyTab: {
    status: string;
    recordUuid: GlobalCompanyTabUUID;
    record: {
      id: GlobalCompanyTabID;
      uuid: GlobalCompanyTabUUID;
      nanoId: GlobalCompanyTabNanoID;
      name: GlobalCompanyTabName;
      content: string | null;
      position: GlobalCompanyTabPosition;
      type: GlobalCompanyTabType;
      companyType: GlobalCompanyTabCompanyType;
      createdAt: GlobalCompanyTabCreatedAt;
      updatedAt: GlobalCompanyTabUpdatedAt;
      userId: GlobalCompanyTabUserID;
      user: GlobalCompanyTabUser;
      roles: GlobalCompanyTabRole[];
    };
    errors: {
      name: UpdateItemGqlError;
      content: UpdateItemGqlError;
      companyType: UpdateItemGqlError;
      position: UpdateItemGqlError;
      fullMessages: string[];
    };
  };
}

export const UPDATE_GLOBAL_COMPANY_TAB_QUERY = gql`
  mutation UpdateGlobalCompanyTab(
    $uid: Uid!
    $name: String
    $content: String
    $companyType: String
    $position: Int
    $roleUids: [Uid!]
  ) {
    updateGlobalCompanyTab(
      input: {
        uid: $uid
        name: $name
        content: $content
        companyType: $companyType
        position: $position
        roleUids: $roleUids
      }
    ) {
      errors {
        fullMessages
        name
        content
        companyType
        position
      }
      record {
        companyType
        content
        createdAt
        id
        name
        nanoId
        position
        type
        updatedAt
        userId
        uuid
        user {
          id
          nanoId
        }
        roles {
          id
          name
          nanoId
          uuid
        }
      }
      recordUuid
      status
    }
  }
`;
